import { render, staticRenderFns } from "./FilialeMain.vue?vue&type=template&id=2e70e212"
import script from "./FilialeMain.vue?vue&type=script&lang=ts"
export * from "./FilialeMain.vue?vue&type=script&lang=ts"
import style0 from "./FilialeMain.vue?vue&type=style&index=0&id=2e70e212&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports